import React, { useState, useRef } from 'react';
import { ModuleBase, UmbracoForm } from '@/components';
import { useTranslation } from 'next-i18next';
import { scrollIntoView } from '@/utils';
import { isColorDark, fixColor } from '@/utils';

const FormModule = ({ data }) => {
  const [submitted, setSubmitted] = useState(false);
  const { t } = useTranslation('common');
  const sucessMessage = useRef();

  const formDefinition = data.formFields;

  const onSubmitSuccessful = () => {
    setSubmitted(true);

    setTimeout(() => {
      scrollIntoView(sucessMessage.current);
    }, 500);
  };
  const isLight = isColorDark(fixColor(data.backgroundColour));
  const isBlackBorder =
    data.backgroundColour === '#f7f2e8'
      ? '[&_.input]:border [&_.input]:border-black [&_.input]:focus:border-black [&_.input:focus]:!border-black'
      : '';

  return (
    <ModuleBase data={{ ...data }} className="text-black">
      <div ref={sucessMessage} className="container px-s sm:max-w-[482px] sm:px-xs lg:max-w-[896px]">
        <UmbracoForm
          className={`[&_.buttons-container]:mt-m [&_.buttons-container]:sm:justify-center [&_.buttons-container]:lg:justify-start ${isBlackBorder}`}
          successClass="text-center py-10 font-larken text-2xl font-light leading-7 md:text-desktop-medium md:leading-desktop-medium"
          submitBtnClass={`btn secondary ${isLight ? 'light' : 'dark'} w-full sm:w-auto`}
          formDefinition={formDefinition}
          onSubmitSuccessful={onSubmitSuccessful}
          isLight
        />
        {!submitted && (
          <div className="color-from-bg mt-m text-btn font-s-light not-italic leading-tiny-paragraph">
            {t('forms.$mandatoryfields')}
          </div>
        )}
      </div>
    </ModuleBase>
  );
};

export default FormModule;
